import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Team from './pages/Team';
import Contact from './pages/Contact';
import NewsFeedPage from './pages/NewsFeedPage';
import SingleNewsPost from './pages/SingleNewsPost';
import Admin from './pages/Admin';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
`;

// Admin Layout - No header/footer
const AdminLayout = styled.div`
  min-height: 100vh;
  background-color: #f5f5f5;
`;

// Main Website Layout - With header/footer
const MainLayout = ({ children }) => (
  <AppContainer>
    <Header />
    <MainContent>
      {children}
    </MainContent>
    <Footer />
  </AppContainer>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin Routes - Separate layout without header/footer */}
        <Route path="/admin" element={
          <AdminLayout>
            <Admin />
          </AdminLayout>
        } />
        
        {/* Main Website Routes - With header/footer */}
        <Route path="/*" element={
          <MainLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/news" element={<NewsFeedPage />} />
              <Route path="/news/:id" element={<SingleNewsPost />} />
              <Route path="/team" element={<Team />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </MainLayout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
